// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x1-i","content":"styles_content__2uQWt"};